import { render, staticRenderFns } from "./projectStatussesTable.vue?vue&type=template&id=78487dba"
import script from "./projectStatussesTable.vue?vue&type=script&lang=ts"
export * from "./projectStatussesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports